import { useEffect, useState } from 'react';

import { AuthenticatedAccount } from '@client:common/AuthenticatedAccount';
import { GlobalStore } from '@client:common/global-store';
import { Icon } from '@client:common/icon';
import { Button } from '@client:common/button';

import { ResetPassword } from './views/reset-password/ResetPasword';
import { AccountForm } from './views/account-form/AccountForm';

import './AccountPage.dark.scss';
import './AccountPage.light.scss';

export const AccountPage = (props: any) => {

  const [activeTab, setActiveTab] = useState('account-details');

  const [authenticatedAccount, setAuthenticatedAccount] =
    useState<AuthenticatedAccount>(null);

  useEffect(() => {
    const globalStore = GlobalStore.getInstance();

    const subscription = globalStore.select('authenticatedAccount').subscribe({
      next: setAuthenticatedAccount
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return (
    <div className='account-page-wrapper'>
      <div className='account-page-navigation-column'>
        <div>
          <Button
            style='basic'
            color={'primary'}
            className={`navigation-column_page-trigger ${activeTab === 'account-details' ? 'active' : ''
              }`}
            onClick={() => {
              setActiveTab('account-details');
            }}
          >
            <Icon icon='person' className='nav-icon' />
            <span className='nav-text'>Account Details</span>
          </Button>

          <Button
            style='basic'
            color={'primary'}
            className={`navigation-column_page-trigger ${activeTab === 'reset-password' ? 'active' : ''
              }`}
            onClick={() => {
              setActiveTab('reset-password');
            }}
          >
            <Icon icon='lock_reset' className='nav-icon' />
            <span className='nav-text'>Reset Password</span>
          </Button>
        </div>

        <div className='navigation-column_support-container '>
          <div
            className="feedback-button-container"
            onClick={() => props.setShowSurveyModal(true)}>
            <Icon
              icon="feedback"
              className='support-container_icon'
            />
            <span className='support-text'>Open Survey Dialog</span>
          </div>
          <div className="feedback-button-container">
            <Icon
              icon='contact_support'
              className='support-container_icon' />
            <div className='support-text'>
              <span>To contact us, email </span>
              <a
                className='support-container_email-trigger'
                href='mailto:mspes@pnnl.gov'
              >
                mspes@pnnl.gov
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className='account-page-content-column'>
        {activeTab && activeTab === 'account-details' && (
          <AccountForm userData={authenticatedAccount} />
        )}
        {activeTab && activeTab === 'reset-password' && <ResetPassword />}
      </div>
    </div>
  );
};
